module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./MessageView.js"));
	}, "MessageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MessageView!./src/pages/Shop/Member/Personal/Message/MessageView.js
// module id = 1890
// module chunks = 367